export default "__VITE_ASSET__35daae23__"